// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ngx-monaco-editor {
  object-fit: fill;
  height: 95vh;
}`, "",{"version":3,"sources":["webpack://./src/app/components/models/model-view/model-view.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;AACF","sourcesContent":["ngx-monaco-editor {\n  object-fit: fill;\n  height: 95vh;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
